<template>
  <div class="vx-row mb-2 -mt-1">
    <div class="vx-col w-full" :class="calculateSize">
      <span class="text-xs">{{structure.label}}</span>
      <v-select
        multiple
        class="w-full"
        name="field"
        v-validate="structure.validation"
        v-model="selected"
        :options="structure.data"
        :dir="$vs.rtl ? 'rtl' : 'ltr'"
      />

      <span class="text-danger text-sm" v-show="errors.has('field')">{{ errors.first('field') }}</span>
    </div>
  </div>
</template> 
<script>
import vSelect from "vue-select";
import { sidebarMixin } from "../sidebarMixin";
export default {
  mixins: [sidebarMixin],
  components: {
    vSelect,
  },
  props: {
    index: String,
    structure: {
      type: Object,
      default: () => {},
      required: true,
    },
    value: String,
    validation: "",
    size: String,
  },
  data() {
    return {
      appendToBody: true,
      selected: this.thevalue,
    };
  },

  computed: {
    thevalue() {
      return this.value != null ? JSON.parse(this.value) : "";
    },
    calculateSize() {
      return this.size == undefined ? "w-full" : this.size;
    },
  },
  created() {
    //we emit the default value because if user does not touch it won't be captured in the array

    if (this.value != null && this.value != undefined) {
      this.selected = JSON.parse(this.value);
    }
    this.$emit("input", { index: this.index, value: this.value });

    this.$watch("selected", (value) => {
      var errorVal = false;
      if (value != null) {
        errorVal = true;
        value = JSON.stringify(value);
      }
      value = value.replace(/this.index/g, "");
      this.$emit("error", { index: this.index, value: errorVal });
      this.$emit("input", { index: this.index, value: value });
    });
  },
};
</script>